"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var UserState_init_1 = require("@/pages/common/states/UserState.init");
exports.userReducer = function (state, action) {
    if (state === void 0) { state = UserState_init_1.defaultUserstate; }
    switch (action.type) {
        case typesafe_actions_1.getType(UserAction_1.default.setUser): {
            return action.payload;
        }
    }
    return state;
};
